import { useState, useEffect } from 'react'
import { lightTheme } from '@/customTheme'
import MiniMenu from './MiniMenu'
import { customAmplitude } from '@/utils/customAmplitude'
import { handleContactUs } from '@/utils/contactUs'
import { NavbarButtonBaseProps } from '../navbarConfig'
import { FloatingInspectorButtonIcon } from '../../FloatingInspectorButton/FloatingInspectorButtons'
import WrapPopover from '../../FloatingInspectorButton/SharedComponents/Popover/WrapPopover'
import Icons from '../../Icons'

function GuestMenuContent({
  buttonRef,
  closePopover,
  hideTryRemoveObjects,
}: {
  buttonRef: React.RefObject<HTMLElement>
  closePopover: () => void
  hideTryRemoveObjects?: boolean
}) {
  const [isOpenContactMenu, setIsOpenContactMenu] = useState(false)
  const [isOpenSelectLanguage, setIsOpenSelectLanguage] = useState(false)

  useEffect(() => {
    customAmplitude('Open Settings')
  }, [])

  const handleClose = () => {
    setIsOpenContactMenu(false)
    setIsOpenSelectLanguage(false)
    closePopover()
  }

  return (
    <WrapPopover padding={16} width={292} gap={0} placement="bottomRight" buttonRef={buttonRef}>
      <MiniMenu
        handleClickContact={handleContactUs}
        isOpenContactMenu={isOpenContactMenu}
        setIsOpenContactMenu={setIsOpenContactMenu}
        isOpenSelectLanguage={isOpenSelectLanguage}
        setIsOpenSelectLanguage={setIsOpenSelectLanguage}
        closeMenu={handleClose}
        hideTryRemoveObjects={hideTryRemoveObjects}
      />
    </WrapPopover>
  )
}

interface GuestMenuPopoverProps extends NavbarButtonBaseProps {
  hideTryRemoveObjects?: boolean
}

function GuestMenuPopover({ disabled = false, hideTryRemoveObjects = false }: GuestMenuPopoverProps) {
  return (
    <FloatingInspectorButtonIcon
      onClick={() => {}}
      disabled={disabled}
      disabledStyle="transparentBackground"
      borderRadiusStyle="rounded"
      style={{ width: '40px', padding: '0 8px' }}
      icon={
        <Icons.Dots
          fill={disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
        />
      }
      popoverContent={(buttonRef, closePopover) => (
        <GuestMenuContent
          buttonRef={buttonRef}
          closePopover={closePopover}
          hideTryRemoveObjects={hideTryRemoveObjects}
        />
      )}
    />
  )
}

export default GuestMenuPopover
